import { useState, useRef, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const newId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `m-${Date.now()}-${Math.random().toString(16).slice(2)}`;

const getSessionId = () => {
  let id = sessionStorage.getItem("nesan_session");
  if (!id) {
    id = newId();
    sessionStorage.setItem("nesan_session", id);
  }
  return id;
};

export function useChat() {
  const [messages, setMessages] = useState([]);
  const [status, setStatus] = useState("idle"); // idle | loading | error | rate_limit
  const [errorMsg, setErrorMsg] = useState("");
  const sessionRef = useRef(getSessionId());

  const isBusy = status === "loading" || status === "rate_limit";

  const send = useCallback(
    async (text) => {
      if (status === "loading" || status === "rate_limit") return;

      const history = messages.map((m) => ({ role: m.role, content: m.content }));
      const nextMessages = [...messages, { id: newId(), role: "user", content: text }];
      setMessages(nextMessages);
      setStatus("loading");
      setErrorMsg("");

      try {
        const res = await axios.post(`${API}/chat`, {
          session_id: sessionRef.current,
          message: text,
          history,
        });
        setMessages([
          ...nextMessages,
          { id: newId(), role: "assistant", content: res.data.reply },
        ]);
        setStatus("idle");
      } catch (err) {
        const data = err?.response?.data;
        if (data?.type === "rate_limit") {
          setErrorMsg(data.message);
          setStatus("rate_limit");
        } else {
          setErrorMsg(
            data?.message ||
              "I'm briefly offline. Try again in a moment, or reach the real Thamel using the links below."
          );
          setStatus("error");
        }
      }
    },
    [messages, status]
  );

  return { messages, status, errorMsg, isBusy, send };
}
